// Tokens visuais do chat (design.md, seção 2.6). Fonte e tamanho base seguem o theme/typography.js do Spark.
export const corPrimaria = '#233980';
export const corBorda = '#d9dde8';
export const corFundo = 'white';
export const corFundoSuave = '#f4f6fb';
export const corTexto = '#1f2937';
export const corTextoSuave = '#5b6475';
export const corErro = '#b3261e';
export const corErroFundo = '#fdecea';
export const fonte = 'Inter, Roboto, sans-serif';
export const tamanhoBase = '14px';
